<template>
  <section v-if="request">
    <v-dialog v-model="show" max-width="500" persistent>
      <v-card>
        <v-container fluid grid-list-md>
          <v-row style="margin: 0">
            <p>¿Está seguro que desea finalizar el servicio?</p>
          </v-row>
          <v-row style="margin: 0">
            <v-spacer />
            <v-btn
              color="rapired"
              style="margin-right: 24px"
              dark
              @click="$emit('close-dialog')"
            >
              NO</v-btn
            >
            <v-btn color="secondary" @click="save"> SI </v-btn>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
export default {
  name: "finalize-service",
  props: {
    show: Boolean,
    visit: Object,
    request: Object,
  },
  methods: {
    save() {
      const visitId = this.visit.id;

      const body = {
        id: 17,
        signature: null,
      };
      this.axios.post(`/visit/${visitId}/status/`, body).then((response) => {
        this.$emit("reload-request");
        this.$emit("close-dialog");
      });
    },
  },
};
</script>
